import React from 'react'
import { UploadIcon, UserPenIcon, ZapIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'

type ProductsUpdateActionGroupProps = {
	isBulkUpdateActionsDisabled?: boolean
	onManualUpdateModal?: () => void
	onFileUpdateModal?: () => void
}

export default function ProductsBulkActionsDropdownMenu(
	props: ProductsUpdateActionGroupProps
) {
	const { t } = useTranslation()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				asChild
				disabled={props.isBulkUpdateActionsDisabled}
				data-testid='products-bulk-actions-trigger'
			>
				<Button size='sm'>
					<ZapIcon />
					{t('general_bulk_update', { defaultValue: 'Bulk update' })}
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent>
				<ProductsUpdateActionsGroup {...props} />
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
export function ProductsUpdateActionsGroup({
	onManualUpdateModal,
	onFileUpdateModal,
	isBulkUpdateActionsDisabled,
}: ProductsUpdateActionGroupProps) {
	const { t } = useTranslation()

	return (
		<DropdownMenuGroup>
			<DropdownMenuLabel>
				{t('general_bulk_update', { defaultValue: 'Bulk update' })}
			</DropdownMenuLabel>
			{onManualUpdateModal && (
				<DropdownMenuItem
					data-testid='products-bulk-actions-manual-update-trigger'
					onClick={onManualUpdateModal}
					disabled={isBulkUpdateActionsDisabled}
				>
					<UserPenIcon />
					{t('import_dropdown_bulk_update')}
				</DropdownMenuItem>
			)}
			{onFileUpdateModal && (
				<DropdownMenuItem
					data-testid='products-bulk-actions-file-update-trigger'
					onClick={onFileUpdateModal}
					disabled={isBulkUpdateActionsDisabled}
				>
					<UploadIcon />
					{t('import_dropdown_data_import')}
				</DropdownMenuItem>
			)}
		</DropdownMenuGroup>
	)
}
